import { render, staticRenderFns } from "./shop-product-items.vue?vue&type=template&id=efbb3b96&scoped=true&"
import script from "./shop-product-items.vue?vue&type=script&lang=js&"
export * from "./shop-product-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbb3b96",
  null
  
)

export default component.exports